import React, { useMemo, useState } from "react";
import styled from "styled-components";
import Table from "common/graphs/Table/Table";
import { atoiv6, atoiv4 } from "common/utils";
import Masked from "common/Masked";

const doesNothing = () => {};

const getColumns = (onEdit, onDelete) => {
  return [
    {
      label: "ADDRESS",
      id: "address",
      numeric: false,
      parse: (value) => {
        if (!value) {
          return 0;
        }
        return value.includes(":") ? atoiv6(value) : atoiv4(value);
      },
      parseFilter: (value) => value
    },
    {
      label: "DESCRIPTION",
      id: "description",
      numeric: false,
    },
    {
      label: "SECRET",
      id: "secret",
      numeric: false,
      renderCell: (value) => <Masked value={value} />,
    },
    {
      label: "ACTIONS",
      id: "ACTIONS",
      actions: [
        {
          label: "Edit",
          icon: "edit",
          onClick: (row) => onEdit(row["__id"]),
        },
        {
          label: "Delete",
          icon: "delete",
          onClick: (row) => onDelete([row["__id"]]),
        },
      ],
    },
  ];
};

const ClientsList = ({
  items = [],
  onDelete = doesNothing,
  onEdit = doesNothing,
}) => {
  const [selected, setSelected] = useState([]);
  const columns = useMemo(() => getColumns(onEdit, onDelete), [onEdit, onDelete]);

  const filteredItems = items.filter(({ deleted }) => deleted !== true).map((item, index) => ({
    ...item,
    id: item.__id !== undefined ? item.__id : index
  }));

  return (
    <Table
      columns={columns}
      data={filteredItems}
      exportCSV={false}
      isSelectable={true}
      isRowSelectable={false}
      selected={selected}
      setSelected={setSelected}
      deleteSelected={(values) => {
        onDelete(values);
        setSelected([]);
      }}
    />
  );
};
export default ClientsList;
